import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { GprMaterialsV1Service, NmdCalculationResponseWrapperDto, RequiredCalculationDto } from "./GPRMV1Service.Generated";
import { takeUntil, tap } from "rxjs/operators";
import { AppService } from "./app.service";
import { Subject } from "rxjs";
import { DataSetSettingEnum } from "../../shared/enums/data-set-setting.enum";


@Injectable()
export class ReCalculateService implements OnDestroy {
    private _destroySubscriptions: Subject<boolean> = new Subject();
    isExistingBuildingSelected: boolean;
    isGprGebouwCalculation: boolean;
    isExistingBuildingCalculation: boolean;
    dataSetSetting = DataSetSettingEnum;
    constructor(
        private _gprMaterialService: GprMaterialsV1Service,
        private _appService: AppService
    ) {

        this.isGprGebouwCalculation = this._appService.getIsGprGebouwCalculation();
        this.isExistingBuildingSelected = this._appService.isExistingBuildingCalculation;
        this.isExistingBuildingCalculation = this._appService.getIsExistingBuildingCalculation();
    }

    /**
    * disposes the resource in the subscriptions
    */
    ngOnDestroy(): void {
        this._destroySubscriptions.next(undefined);
        this._destroySubscriptions.complete();
    }

    /**
      * re Calculate with out validation
      */
    reCalculateWithoutValidation() {
        this._gprMaterialService.reCalculateCalculationWithoutValidation(this._appService.getCalculationUrlId(),
        this._appService.isExistingBuildingCalculation).pipe(
                takeUntil(this._destroySubscriptions),
            tap((nmdCalculationResponseWrapper: NmdCalculationResponseWrapperDto) => {
                    if (nmdCalculationResponseWrapper) {
                        if (this._appService.isExistingBuildingCalculation) {
                            const datasetChoiceId = this._appService.getDatasetChoiceId();
                            this._appService.setIsExistingBuildingCalculation$(this._appService.isExistingBuildingCalculation);
                            if (datasetChoiceId == this.dataSetSetting.A1) {
                                this._appService.setMpgAfterValue(nmdCalculationResponseWrapper.existingBuildingAfterResultsA1.mpg);
                                this._appService.setMpgValue(nmdCalculationResponseWrapper.existingBuildingCurrentResultsA1.mpg);
                            }
                            else if (datasetChoiceId == this.dataSetSetting.A2) {
                                this._appService.setMpgAfterValue(nmdCalculationResponseWrapper.existingBuildingAfterResultsA2.mpg);
                                this._appService.setMpgValue(nmdCalculationResponseWrapper.existingBuildingCurrentResultsA2.mpg);
                            }
                        }
                    }
                })
            ).subscribe(
                () => this.fetchCalculationByUrlIdWithReqNavProps()
            );
    }

    /**
       * Calling an API to get calculation with required navigational parameter
    */
    fetchCalculationByUrlIdWithReqNavProps() {
        this._appService.fetchCalculationByUrlIdWithReqNavProps()
            .pipe(takeUntil(this._destroySubscriptions))
            .subscribe((resp: RequiredCalculationDto) => {

                // Updating gpr modal tree data
                this._appService.updateModelTreeProjectModel$.emit();

            });
    }
}
